<template>
  <Card :bordered="true" dis-hover>
    <p slot="title">
      <slot name="title"></slot>
    </p>
    <!-- <a href="#" slot="extra">
      <Button
        size="small"
        type="dashed"
        class="extra-btn"
        @click="goToDevice"
        v-if="hasPageAccess('DEVICE_REPORT_NEW')"
      >
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
      <slot name="extra"></slot>
    </a> -->
    <div class="device-status">
      <div id="data-left">
        <!-- <echart :options="videoDeviceOption"></echart> -->
      </div>
      <div id="data-right">
        <!-- <echart :options="dmsDeviceOption"></echart> -->
      </div>
      <!--<div class="data-item">
        <echart :options="depDeviceOption"></echart>
      </div>-->
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import * as echarts from 'echarts';
import { privileageAccess } from '../../../mixins/privileage';
export default {
  mixins: [privileageAccess],
  data() {
    return {
      videoDeviceOption: {},
      depDeviceOption: {},
      dmsDeviceOption: {},
      myChart: null,
      myChart2: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
      this.myChart2 && this.myChart2.resize();
    },
    getData() {
      const userInfo = this.$system.$state.userInfo;
      const enterpriseId = userInfo && userInfo.groupId ? userInfo.groupId : '';
      api
        .getDeviceStatistics({ enterpriseId })
        .then(res => {
          this.data = res;
          this.initLeftEcharts();
          this.initRightEcharts();
        })
        .catch(error => {
          console.error(`${this.$t('home.error_getdevicedata')}:${error}`);
        });
    },
    initLeftEcharts() {
      let myChart = echarts.init(document.getElementById('data-left'), null, { renderer: 'svg'});
      let { videoOnline, videoTotal } = this.data;
      let colorRegionRate = +((videoOnline / videoTotal) * 100).toFixed(2);
      let option = {
        series: [
          {
            type: 'gauge',
            radius: '65%',
            // radius: ['70%', '80%'],
            center: ['50%', '50%'],
            splitNumber: 0, //刻度数量
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,
              lineStyle: {
                width: 15,
                color: [
                  // 有数值的部分
                  [
                    colorRegionRate / 100,
                    new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: '#31BD6D', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#31BD6D', // 100% 处的颜色
                      },
                    ]),
                  ],
                  // 底色
                  [1, '#E0E8F3'],
                ],
              },
              radius: 8,
            },
            //分隔线样式。
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            title: {
              show: true,
              offsetCenter: [0, '92%'], // x, y，单位px
              color: '#E6E6E6',
              fontSize: 14,
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              offsetCenter: [0, '32%'],
              color: '#31BD6D',
              size: 16,
              formatter: function (params) {
                return params + '%';
              },

              fontSize: 18,
            },
            data: [
              {
                value: colorRegionRate,
                name: this.$t('home.device_videorate'),
              },
            ],
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.myChart = myChart;
    },
    initRightEcharts() {
      let myChart = echarts.init(document.getElementById('data-right'), null, { renderer: 'svg' });
      let { deviceOnline, deviceTotal } = this.data;
      let colorRegionRate = +((deviceOnline / deviceTotal) * 100).toFixed(2);
      let option = {
        series: [
          {
            type: 'gauge',
            radius: '65%',
            // radius: ['70%', '80%'],
            center: ['50%', '50%'],
            splitNumber: 0, //刻度数量
            startAngle: 225,
            endAngle: -45,
            axisLine: {
              show: true,

              lineStyle: {
                width: 15,
                color: [
                  // 有数值的部分
                  [
                    colorRegionRate / 100,
                    new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                      {
                        offset: 0,
                        color: '#68DC9A', // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: '#68DC9A', // 100% 处的颜色
                      },
                    ]),
                  ],
                  // 底色
                  [1, '#E0E8F3'],
                ],
              },
              radius: 8,
            },
            //分隔线样式。
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            pointer: {
              show: false,
            },
            title: {
              show: true,
              offsetCenter: [0, '92%'], // x, y，单位px
              color: '#E6E6E6',
              fontSize: 14,
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: true,
              offsetCenter: [0, '32%'],
              color: '#31BD6D',
              size: 16,
              formatter: function (params) {
                return params + '%';
              },
              fontSize: 18,
            },
            data: [
              {
                value: colorRegionRate,
                name: this.$t('home.device_dmsrate'),
              },
            ],
          },
        ],
      };
      // 绘制图表
      myChart.setOption(option);
      this.myChart2 = myChart;
    },
    goToDevice() {
      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // eslint-disable-next-line no-undef
          system: ccconstants.SYSTEM_NOS.Web_Equipment, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: '/deviceReport', //跳转路径，需要填写在相应系统里面的路由地址
        },
      });
    },
  },
};
</script>
<style lang="scss" type="text/scss">
.device-status {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 10px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  #data-left {
    position: relative;
    width: 40%;
    min-width: 120px;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
    margin: 10px 0;
  }
  #data-right {
    position: relative;
    width: 40%;
    min-width: 120px;
    height: 100%;
    box-sizing: border-box;
    text-align: center;
    margin: 10px 0;
  }
}
@media screen and (min-width: 300px) and (max-width: 768px) {
  .device-status {
    .data-item {
      width: 100%;
      height: 160px;
    }
  }
}
</style>
